<template>
  <CRow>
    <CCol col="12" md="12">
      <CCard>
        <CCardBody>
          <CRow>
            <CCol col="6" md="6">
              <CCard>
                <CCardHeader>
                  <h5 style="color:#4f5d73;">
                    <img src="img/cow (2).svg" style="width:30px;filter: invert(0.5) sepia(1) saturate(5) hue-rotate(-608deg);" /><b>&nbsp;Breed</b> 
                  </h5>
                </CCardHeader>
                <br>
<div class="row">
  <!-- <div clsass="col-sm-4">   <h5> Sepices</h5></div> -->
  <div class="col-sm-6" >
   &nbsp;&nbsp;&nbsp; <Vselect :options="taskslistoption" v-model="species1"   searchable  style="margin-left:10px"/>  
  </div>
  <div class="col-sm-2">
    <CButton color="info" @click="go">
            GO
              </CButton>
  </div>

</div>

                <CCardBody>
                 
                  <CDataTable
                    :items="breedItem1"
                    :fields="fields"
                    items-per-page-select
                    :items-per-page="10"
                    pagination
                    clickable-rows
                    hover
                    @row-clicked="rowClicked"
                    caption="Breed"
                  />
                </CCardBody>
              </CCard>
            </CCol>
<!-- <CCol col="6" md="2">
</CCol> -->
            <CCol col="6" md="6">
              <CTabs add-tab-classes="mt-1">
                <CTab>
                  <template slot="title">
                    <h5 style="color:#4f5d73;">
                    <img src="img/cow (2).svg" style="width:30px;filter: invert(0.5) sepia(1) saturate(5) hue-rotate(-608deg);" /> <b >Breed Details</b>
                  </h5>
                  </template>
                  <CRow>
                    <CCol col="6" md="12">
                      <CCard>
                        <!-- <CCardHeader>
                      <p>
                        <img src="img/factory.svg" style="width:20px" /> Breed Details
                      </p>
                        </CCardHeader>-->
                        <CCardBody>
                          <CForm>
                            <br>
                            <br>
                            <br>
                            <br>
                            <CInput
                              label="Breed Code"
                              v-model="breedCode"
                              name="breedCode"
                              id="breedCode"
                              required
                              horizontal
                              autocomplete="name"
                            />

                            <CInput
                              label="Breed Name"
                              v-model="breedName"
                              name="breedName"
                              id="breedName"
                              required
                              horizontal
                              autocomplete="name"
                            />
                            <CSelect
                              label="Species"
                              horizontal
                              :options="options"
                              placeholder="Please select"
                              v-model="species"
                              name="species"
                              id="species"
                              :value.sync="species"
                            />
                          </CForm>
                        </CCardBody>
                        <CCardFooter>
                          <CButton
                            color="info"
                            style="width:100px"
                            v-if="addButton"
                            @click="addBreed"
                          >
                            <CIcon name="cilPencil" />&nbsp;Add
                          </CButton>&nbsp;
                          <CButton
                            color="success"
                            style="width:100px"
                            v-if="saveButton"
                            @click="updateBreed"
                          >
                            <CIcon name="cilCheck" />&nbsp;Save
                          </CButton>&nbsp;
                          <CButton
                            color="danger"
                            style="width:100px"
                            v-if="deleteButton"
                            @click="deleteBreed"
                          >
                            <CIcon name="cilXCircle" />&nbsp;Delete
                          </CButton>&nbsp;
                          <CButton
                            color="success"
                            style="width:100px"
                            v-if="EditsaveButton"
                            @click="addBreed"
                          >
                            <CIcon name="cilCheck" />&nbsp;Save
                          </CButton>&nbsp;
                          <CButton
                            color="secondary"
                            style="width:100px"
                            v-if="cancelButton"
                            @click="CancelBreed"
                          >
                            <CIcon name="cilWarning" />&nbsp;Cancel
                          </CButton>&nbsp;
                          <CButton color="info" v-if="addnewButton" @click="addBreedplus">
                            <CIcon name="cilPencil" />&nbsp;Add New
                          </CButton>
                        
                        </CCardFooter>
                      </CCard>
                    </CCol>

                   
                  </CRow>
                </CTab>
                <CTab>
                  <template slot="title">
                    <h5 style="color:#4f5d73;"><img src="img/to-do-list.svg" style="width:20px;filter: invert(0.5) sepia(1) saturate(5) hue-rotate(-379deg);" />
                  <b>Tasks</b> </h5>
                  </template>
                  <!-- <tasks></tasks> -->
  <CCard>
          <CCardHeader>
            <!-- <CInput
                              label="Action plan for "
                              v-model="breedName"
                              name="breedNameTitle"
                              id="breedNameTitle"
                              required
                              horizontal
                              autocomplete="name"
                            /> -->
                            <h5>Action plan for : {{breedName}}</h5>
          </CCardHeader>
          <CCardBody>
            <CTabs add-tab-classes="mt-1">
              <CTab>
                <template slot="title">
                   <h5  style="color:#4f5d73;">Action plan</h5>      
                </template>
                          
                    <CDataTable
                      :items="items1"
                      :fields="fields1"
                      :items-per-page="20"
                      clickable-rows
                      hover
                      @row-clicked="rowClicked"
                      caption="Breed"
                    />
                   <CButton color="info" @click="infoModal = true" class="mr-1">
                            <CIcon name="cilPencil" />&nbsp;Add Task
                          </CButton>
              </CTab>
              <CTab >
                <template slot="title">
                <h5  style="color:#4f5d73;">Alarm</h5>   
                </template>
                2. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore
                et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
                officia deserunt mollit anim id est laborum.
              </CTab>
              <CTab>
                <template slot="title">
                   <h5  style="color:#4f5d73;">Graph</h5>   
                </template>
                3. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore
                et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
                officia deserunt mollit anim id est laborum.
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
                 
                </CTab>
              </CTabs>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
    <!-- <CModal
      title="Modal title"
      color="info"
      :show.sync="infoModal"
    >
     
    </CModal>-->

    <CModal title="Modal title" color="info" :show.sync="infoModal">
      <template #header>
        <h6 class="modal-title">Add Tasks</h6>
        <CButtonClose  class="text-white" />
      </template>
      <CCol col="12" md="12">
        <CCardHeader>
          <p>
            <img src="img/factory.svg" style="width:20px" /> Tasks Details
          </p>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <div class="row">
  <div class="col-sm-4">BreedName</div>
  <div class="col-sm-8">   <Vselect :options="taskslistoption" v-model="breedName" searchable />
</div>
</div>
<br>
            <CInput
              label="NO"
              v-model="number"
              name="no"
              id="no"
              required
              horizontal
              autocomplete="name"
            />

            <CInput
              label="Tasks"
              v-model="task"
              name="tasks"
              id="tasks"
              required
              horizontal
              autocomplete="name"
            />
             <CInput
              label="Plus/Minus"
              v-model="plus_minus"
              name="tasks"
              id="tasks"
              required
              horizontal
              autocomplete="name"
            />
            <CInput
              label="Days"
              v-model="day"
              name="days"
              id="days"
              required
              horizontal
              autocomplete="name"
            />
          </CForm>
        </CCardBody>
      </CCol>
      <template #footer>
        <!-- savetaskBreed -->
        <CButton color="success" style="width:100px" @click="addBreed">Save</CButton>
        <CButton color="secondary" style="width:100px" @click="CancelBreed">Cancel</CButton>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import CTableWrapper from "../../tables/Table";
import { APIService } from "../../../apiservice.js";
import { Vselect } from "@/components";
import Swal from "sweetalert2";
export default {
  components: { CTableWrapper, Vselect },

  data() {
    return {
      species1:null,
      breedItem1:[],
       tabs: [
        'Calculator',
        'Shopping cart',
        'Charts'
      ],
      infoModal: false,
      breedCode: null,
      breedName: "",
      species: "",
      // no: [],
      // tasks: [],
      // days: [],
      // plus_minus:[],
      breedItem: [],
      editBreed: [],
      taskItem: [],
      taskslistoption:[],
      options: ["", "Cow", "Buffalo"],
      tabs: ["Action plan", "Alarm","Graph"],
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      fields: [
        {
          key: "breedCode",
          sortable: true,
          _style:'width:10%'
        },
        {
          key: "breedName",
          sortable: true,
          _style:'width:20%'
        },
        {
          key: "species",
          sortable: true,
           _style:'width:20%'
        }
      ],
      fields1: [
        {
          key: "number",
          sortable: true,
          _style:'width:10%'
        },
        {
          key: "task",
          sortable: true,
          _style:'width:40%'
        },
          {
          key: "days",
          sortable: true,
          _style:'width:10%'

        },
        {
          key: "plus_minus",
          sortable: true,
          _style:'width:10%'
        }
      ],
      items1: [
      // { isActive: true, Sire_No: "AVN0001",Sire_Name: "Adasholai", Species:"2",Breed:"2",Purchase_Source:"2",status: 'Active' },
    //   { isActive: true, number: "50",task: "Expected First Heat After Calving(Days)", days:"3",plus_minus:"+-", },
    //     { isActive: true, number: "21",task: "Interval Between Subsequent Heats", days:"3",plus_minus:"+-", },
    //    { isActive: true, number: "60",task: "preg.Check 1(PD-1) Adter AI", days:"2",plus_minus:"+-", },
    //     { isActive: true, number: "4",task: "preg.Check 1(PD-2) Adter AI", days:"2",plus_minus:"+-", },
    //      { isActive: true, number: "5",task: "Animal To Be Dried in Next (Days)", days:"2",plus_minus:"+-", },
    //     { isActive: true, number: "6",task: "Insurance Due Date", days:"3",plus_minus:"+-", },
    // { isActive: true, number: "7",task: "Milk Entry Interval", days:"2",plus_minus:"+-", },
    //      { isActive: true, number: "8",task: "FMD(Months)", days:"3",plus_minus:"+-", },
    //     { isActive: true, number: "9",task: "HS/B", days:"3",plus_minus:"+-", },
    // { isActive: true, number: "8",task: "Medicine follow up", days:"3",plus_minus:"+-", },
    //     { isActive: true, number: "9",task: "Due for body weight", days:"3",plus_minus:"+-", },
    //      { isActive: true, number: "9",task: "Due for Disease testing", days:"4",plus_minus:"+-", },
    // { isActive: true, number: "8",task: "Due for Deworming", days:"3",plus_minus:"+-", },
    //     { isActive: true, number: "9",task: "Due for Vaccination", days:"4",plus_minus:"+-", },
      { isActive: true, number: "1",task: "Expected First Heat After Calving(Days)", days:"50",plus_minus:"+/- 3", },
        { isActive: true, number: "2",task: "Interval Between Subsequent Heats", days:"21",plus_minus:"+/- 3", },
       { isActive: true, number: "3",task: "preg.Check 1(PD-1) Adter AI", days:"60",plus_minus:"+/- 2", },
        { isActive: true, number: "4",task: "preg.Check 1(PD-2) Adter AI", days:"90",plus_minus:"+/- 2", },
         { isActive: true, number: "5",task: "Animal To Be Dried in Next (Days)", days:"15",plus_minus:"+/- 2", },
        { isActive: true, number: "6",task: "Insurance Due Date", days:"3",plus_minus:"+/- 12", },
    { isActive: true, number: "7",task: "Milk Entry Interval", days:"2",plus_minus:"+/- 15", },
         { isActive: true, number: "8",task: "FMD(Months)", days:"3",plus_minus:"+/- 6", },
        { isActive: true, number: "9",task: "HS/BQ(Months)", days:"3",plus_minus:"+/- 12", },
    { isActive: true, number: "10",task: "IBR(Months)", days:"3",plus_minus:"+/- 12", },
        { isActive: true, number: "11",task: "Deworming(Months)", days:"3",plus_minus:"+/- 6", },
    //      { isActive: true, number: "",task: "Due for Disease testing", days:"9",plus_minus:"+/- 4", },
    // { isActive: true, number: "",task: "Due for Deworming", days:"8",plus_minus:"+/- 3", },
    ]

    };
  },
  // watch:{
   
  // },
  methods: {
     go(){
  this.breedItem1 = this.breedItem.filter( n=>
 n.species == this.species1 )
  },
    getBreedList() {
      APIService.breedList().then(res => {
        if (res.status == 200) {
          this.breedItem = res.data;
          this.breedItem1 = res.data;
             this.breedCode = this.breedItem[0].breedCode;
      this.breedName = this.breedItem[0].breedName;
       this.species = this.breedItem[0].species;
          // console.log("data", this.taskItem )
            let value = this.breedItem.map(n => {
            return n.species;
          });
//  this.taskslistoption = value;
        


let uniqueChars = value.filter((c, index) => {
    return value.indexOf(c) === index;
});

  this.taskslistoption = uniqueChars;
          console.log("valuse", uniqueChars);

        }
      });
    },

    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);
      let id = this.editBreed._id;
      this.editBreed = item;
      this.breedCode = item.breedCode;
      this.breedName = item.breedName;
       this.breedNameTitle = item.breedName;
      this.species = item.species;
      // this.number = item.number;
      // this.task = item.task;
      // this.day = item.day;
      // this.plus_minus= item.plus_minus;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
      // this.getBreedList();
    },

    addtaskBreed() {
      let id = this.editBreed._id;
      let breedCode = this.breedCode;
      let breedName = this.breedName;
      let species = this.species;
      // let number = this.number;
      // let task = this.task;
      // let day = this.day;
      // let plus_minus = this.plus_minus;
      let value = {
        breedCode,
        breedName,
        species,
        // number,
        // task,
        // day,
        // plus_minus
      };
      let data = {value, id };
      APIService.savetaskBreed(data).then(res => {
        if (res.status == 200) {
          this.breedCode = null;
          this.breedName = "";
          this.species = "";
          // this.number = "";
          // this.task = "";
          // this.day= "";
          // this.plus_minus="";
          this.addButton = true;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = false;
          this.getBreedList();
            Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },

    addBreed() {
      let id = this.editBreed._id;
      let breedCode = this.breedCode;
      let breedName = this.breedName;
      let species = this.species;
      let number = this.number;
      // let task = this.task;
      // let day = this.day;
      // let plus_minus = this.plus_minus;
      let data = {
        breedCode,
        breedName,
        species,
        number,
        // task,
        // day,
        // plus_minus
      };
      APIService.saveBreed(data).then(res => {
        if (res.status == 200) {
          this.breedCode = null;
          this.breedName = "";
          this.species = "";
          this.number = "";
          // this.task = "";
          // this.day = "";
          // this.plus_minus="";
          this.getBreedList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },
    addBreedplus() {
      this.breedCode = null;
      this.breedName = "";
      this.species = "";
      // this.number = "";
      // this.task = "";
      // this.day = "";
      // this.plus_minus="";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      (this.EditsaveButton = true)
      return getBreedList();
    },

    CancelBreed() {
      this.breedCode = null;
      this.breedName = "";
      this.species = "";
      // this.number = "";
      // this.task = "";
      // this.day = "";
      // this.plus_minus="";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      (this.EditsaveButton = false), this.getBreedList();
    },
    updateBreed() {
      let id = this.editBreed._id;
      let breedCode = this.breedCode;
      let breedName = this.breedName;
      let species = this.species;
      // let number = this.number;
      // let task = this.task;
      // let day = this.day;
      // let plus_minus =this.plus_minus;
      let value = {
        breedCode,
        breedName,
        species,
        // number,
        // task,
        // day,
        // plus_minus
      };
      let data = { id, value };
      APIService.breedUpdate(data).then(res => {
        if (res.status == 200) {
          this.breedCode = null;
          this.breedName = "";
          this.species = "";
          // this.number = "";
          // this.task = "";
          // this.day = "";
          // this.plus_minus="";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          this.getBreedList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },
    deleteBreed() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.delete();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    delete() {
      let id = this.editBreed._id;
      let data = { id };
      APIService.breedDelete(data).then(res => {
        if (res.status == 200) {
          this.breedCode = null;
          this.breedName = "";
          this.species = "";
          // this.number = "";
          // this.task = "";
          // this.day = "";
          // this.plus_minus ="";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false), this.getBreedList();
        }
      });
    }
  },
//   watch:{
// breedName() {
//    let id = this.breedName;
//        console.log("test",this.breedName)
//       let data = { id};
//       APIService.selectBreed(data).then(res => {
//         if (res.status == 200) {
//                 this.breedItem = res.data;
//           Swal.fire({
//             position: "center",
//             icon: "success",
//             title: "Data Saved Successfully",
//             showConfirmButton: false,
//             timer: 2000
//           });
//         }
//       });
// }
//   },
  created() {
    this.getBreedList();
    this.getSpeciesList();
  }
};
</script>
